import React, { Component } from 'react';
import { connect } from 'react-redux';

import { focusAfterTimeout } from '../../util';

import { createUser, updateUserWithRole, stopEditingUser, resendUserInvitation } from '../../actions/users';

import Switch from 'react-switch';

const DEFAULT_USER = {
  firstName: '',
  lastName: '',
  email: '',
  role: 'employee',
}

class UpdateUserModal extends Component{

  state = {
    editingUser: DEFAULT_USER,
    error: null,
    message: null,
    sendWelcomeEmailIfNewUser: false,
  }

  componentWillReceiveProps(nextProps){
    console.log('component received nextprops: ', nextProps);

    //const editingUser = { ...nextProps.editingUser.user };

    const errorForState = nextProps.editingUser.error || null;
    const messageForState = nextProps.editingUser.message || null;
    const userDataForState = nextProps.editingUser.user || DEFAULT_USER;

    this.setState({
      editingUser: userDataForState,
      error: errorForState,
      message: messageForState,
    });

    //focus first input
    if(nextProps.editingUser && nextProps.editingUser.editing){
      focusAfterTimeout(this, 'firstNameInput');
    }

    //
    // if(editingUser){
    //   userDataForState = edit
    //   console.log('editing user: ', editingUser);
    //   this.setState({
    //     editingUser
    //   });
    // }
    // else{
    //   this.setState({
    //     editingUser: DEFAULT_USER
    //   });
    // }
    //
    // if(nextProps.editingUser.error){
    //   errorForState
    // }
    // else{
    //   this.setState({
    //     error: null
    //   });
    // }
  }

  updateUserField(fieldName, fieldValue){
    this.clearErrorAndMessage();

    let updatedUser = {
      ...this.state.editingUser
    }
    updatedUser[fieldName] = fieldValue;

    this.setState({
      editingUser: updatedUser
    });
  }

  clearErrorAndMessage(){
    this.setState({
      error: null,
      message: null,
    });
  }

  createOrUpdateUser(){
    if(this.state.editingUser._id){
      this.props.updateUserWithRole(this.state.editingUser);
    }
    else{
      this.props.createUser(this.state.editingUser, this.state.sendWelcomeEmailIfNewUser);
    }
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else if(this.state.message){
      return <div className="form-message success">{this.state.message}</div>;
    }
    else{
      return <div className="form-message placeholder">&nbsp;</div>;
    }
  }

  formIsDirty(){

    const { userIsNew, user } = this.props.editingUser;

    if( userIsNew ||
      user.firstName !== this.state.editingUser.firstName ||
      user.lastName !== this.state.editingUser.lastName ||
      user.role !== this.state.editingUser.role
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getSaveButtonText(){
    const { syncingWithServer, userIsNew } = this.props.editingUser;

    if(userIsNew){
      if(syncingWithServer){
        return "Creating user...";
      }
      else{
        return "Create new user";
      }
    }
    else{
      if(syncingWithServer){
        return "Saving...";
      }
      else{
        return "Save";
      }
    }

  }

  toggleWelcomeEmailSend(){
    this.setState({
      sendWelcomeEmailIfNewUser: !this.state.sendWelcomeEmailIfNewUser
    });
  }

  renderSendWelcomeEmailSwitch(){
    const { userIsNew } = this.props.editingUser;

    if(!userIsNew){
      return null;
    }

    return (
      <div className="form-group">
        <label htmlFor="send-welcome-email">Send welcome email?</label>
        <Switch
          id="some-switch"
          checked={this.state.sendWelcomeEmailIfNewUser}
          onChange={this.toggleWelcomeEmailSend.bind(this)}
          handleDiameter={20}
          offColor="#D2D2D2"
          onColor="#2D9542"
          offHandleColor="#545B72"
          onHandleColor="#FFFFFF"
          height={28}
          width={60}
          className="react-switch-input"
          ></Switch>
      </div>
    );
  }

  inviteUser(){
    this.props.resendUserInvitation(this.state.editingUser._id);
  }

  render(){

    if(!this.props.editingUser.editing){
      return null;
    }

    const { _id, firstName, lastName, email, role } = this.state.editingUser;

    const isEmployee = role === 'employee';
    const isManager = role === 'manager';
    const isSalesLeader = role === 'salesleader';
    const isAdmin = role === 'admin';

    const isNewUser = _id ? false : true;

    const { syncingWithServer } = this.props.editingUser;

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.stopEditingUser}>X</div>
          <div className="modal-content">
            <form className="velocity-form">
              <h2>{isNewUser ? 'Add' : 'Update'} user</h2>
              {this.renderFormMessage()}
              <div className="form-group">
                <div className="input-group half-width">
                  <label htmlFor="velocity-new-user-first-name">First name</label>
                  <input
                    ref={input => { this.firstNameInput = input; }}
                    id="velocity-new-user-first-name"
                    autoComplete="off"
                    type="text"
                    value={firstName}
                    onChange={e => {this.updateUserField('firstName', e.target.value)}}
                    />
                </div>
                <div className="input-group half-width">
                  <label htmlFor="velocity-new-user-last-name">Last name</label>
                  <input
                    id="velocity-new-user-last-name"
                    autoComplete="off"
                    type="text"
                    value={lastName}
                    onChange={e => {this.updateUserField('lastName', e.target.value)}}
                    />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="velocity-new-user-email">Email Address</label>
                <input
                  id="velocity-new-user-email"
                  type="email"
                  value={email}
                  disabled={!isNewUser}
                  onChange={e => {this.updateUserField('email', e.target.value)}}
                  />
                {!isNewUser && !syncingWithServer &&
                  <div className="input-action" onClick={this.inviteUser.bind(this)}>Resend Invite</div>
                }
              </div>
              {this.renderSendWelcomeEmailSwitch()}
              <div className="form-section">
                <div className="form-section-label">Permissions</div>
                  <div className="form-group">
                    <div className="input-group quarter-width" style={{paddingLeft: '50px'}}>
                      <label>Employee</label>
                      <Switch
                        id="some-switch"
                        disabled={isAdmin && !isNewUser}
                        checked={isEmployee}
                        onChange={checked => { if(checked){ this.updateUserField('role', 'employee'); } }}
                        handleDiameter={20}
                        offColor="#D2D2D2"
                        onColor="#2D9542"
                        offHandleColor="#545B72"
                        onHandleColor="#FFFFFF"
                        height={28}
                        width={60}
                        className="react-switch-input"
                      />
                    </div>
                    <div className="input-group quarter-width" style={{paddingLeft: '50px'}}>
                      <label>Manager</label>
                      <Switch
                        id="some-switch"
                        disabled={isAdmin && !isNewUser}
                        checked={isManager}
                        onChange={checked => { if(checked){ this.updateUserField('role', 'manager'); } }}
                        handleDiameter={20}
                        offColor="#D2D2D2"
                        onColor="#2D9542"
                        offHandleColor="#545B72"
                        onHandleColor="#FFFFFF"
                        height={28}
                        width={60}
                        className="react-switch-input"
                      />
                    </div>
                    <div className="input-group quarter-width" style={{paddingLeft: '50px'}}>
                      <label>Sales Leader</label>
                      <Switch
                        id="some-switch"
                        disabled={isAdmin && !isNewUser}
                        checked={isSalesLeader}
                        onChange={checked => { if(checked){ this.updateUserField('role', 'salesleader'); } }}
                        handleDiameter={20}
                        offColor="#D2D2D2"
                        onColor="#2D9542"
                        offHandleColor="#545B72"
                        onHandleColor="#FFFFFF"
                        height={28}
                        width={60}
                        className="react-switch-input"
                      />
                    </div>
                    <div className="input-group quarter-width" style={{paddingLeft: '50px'}}>
                      <label>Admin</label>
                      <Switch
                        id="some-switch"
                        disabled={isAdmin && !isNewUser}
                        checked={isAdmin}
                        onChange={checked => { if(checked){ this.updateUserField('role', 'admin'); } }}
                        handleDiameter={20}
                        offColor="#D2D2D2"
                        onColor="#2D9542"
                        offHandleColor="#545B72"
                        onHandleColor="#FFFFFF"
                        height={28}
                        width={60}
                        className="react-switch-input"
                      />
                    </div>
                    <p>&nbsp;</p>
                    <p style={{opacity: isEmployee ? 1 : .5}}>Employees can log in and view their own account, as well as be added to teams by admins.</p>
                    <p style={{opacity: isManager ? 1 : .5}}>Managers can view employee information for employees added to their teams</p>
                    <p style={{opacity: isSalesLeader ? 1 : .5}}>Sales Leaders can view data and reporting for all employees, managers, teams, and the organization as a whole</p>
                    <p style={{opacity: isAdmin ? 1 : .5}}>Admins can create and manage all users and teams in the organization</p>
                  </div>
              </div>
            </form>
          </div>
          <div className="modal-actions">
            {!this.formIsDirty() && !syncingWithServer &&
              <button className="button primary" onClick={this.props.stopEditingUser}>Done</button>
            }
            {(this.formIsDirty() || syncingWithServer) &&
              <template>
                <button className="button primary" onClick={this.createOrUpdateUser.bind(this)} disabled={syncingWithServer}>{this.getSaveButtonText()}</button>
                <button className="button grey-button" onClick={this.props.stopEditingUser}>Cancel</button>
              </template>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    editingUser: state.editingUser,
  }
}

export default connect(mapStateToProps, { stopEditingUser, createUser, updateUserWithRole, resendUserInvitation })(UpdateUserModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateUser.js